var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 4847 c-174 -59 -291 -185 -334 -358 -40 -165 6 -329 129 -454 64 -65 121 -102 207 -132 51 -17 139 -18 2208 -18 2069 0 2157 1 2208 18 86 30 143 67 207 132 123 125 169 289 129 454 -43 175 -168 307 -343 361 -62 20 -95 20 -2205 20 l-2141 -1 -65 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 3050 c-206 -30 -366 -175 -419 -377 -65 -247 92 -511 350 -590 57 -17 152 -18 2195 -18 2043 0 2138 1 2195 18 258 79 415 343 350 590 -45 173 -170 305 -345 364 -53 17 -143 18 -2165 19 -1160 1 -2133 -2 -2161 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 1233 c-102 -17 -197 -68 -275 -148 -123 -125 -169 -289 -129 -454 43 -175 168 -307 343 -361 62 -20 95 -20 2201 -20 2106 0 2139 0 2201 20 175 54 300 186 343 361 60 245 -76 487 -330 585 -47 18 -120 19 -2189 20 -1177 1 -2151 -1 -2165 -3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBar);
export default __webpack_public_path__ + "static/media/menu-bar.c18f6280aff03218d411da2f43659c21.svg";
export { ForwardRef as ReactComponent };